exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sheet-count-modal {\n  max-width: 1400px; }\n\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0; }\n\n.qa-button-container {\n  margin: 0px 20px 30px 20px; }\n  .qa-button-container .left-qa-button {\n    margin-right: 20px;\n    font-size: 1.7rem;\n    padding: 1.6rem 4.5rem !important;\n    color: white !important; }\n  .qa-button-container .right-qa-button {\n    margin-left: 20px;\n    font-size: 1.7rem;\n    padding: 1.6rem 4.5rem !important; }\n\n.btn-group {\n  width: 300px !important;\n  height: 100px !important; }\n  .btn-group button {\n    color: #ccc;\n    background-image: none;\n    background-color: transparent;\n    border-color: #ccc;\n    color: #374767;\n    font-weight: bold;\n    font-size: 3rem;\n    background: #f1f1f1; }\n  .btn-group input {\n    font-size: 3rem;\n    color: #374767; }\n\n.bin-number {\n  font-size: 3em !important;\n  font-weight: bold !important;\n  text-align: center !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/modals/sheet-count-modal/sheet-count-modal.component.scss
// module id = ../../../../../src/app/shared/modals/sheet-count-modal/sheet-count-modal.component.scss
// module chunks = main